import React, { useState, useEffect, useCallback } from "react"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { useHistory } from "react-router-dom"
import { Link } from "react-router-dom"
import debounce from "lodash/debounce"
import { toast } from "react-toastify"
import Dropzone from "react-dropzone"
import { URLS } from "../../Url"
import Select from "react-select"
import axios from "axios"
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Row,
  Button,
  Form,
  FormGroup,
} from "reactstrap"

function EditAdvertisements() {
  const [form, setForm] = useState({
    name: "",
    advcategoryId: "",
    priorityId: "",
    fromDate: "",
    toDate: "",
    advtype: "",
    productId: "",
    type: "image",
    deltype: "",
  })

  const [selectedFiles, setSelectedFiles] = useState([])
  const [existingImage, setExistingImage] = useState("")
  const [price, setPrice] = useState("")
  const history = useHistory()
  const [priority, setPriority] = useState([])
  const GetAuth = localStorage.getItem("authUser")
  const TokenJson = JSON.parse(GetAuth)
  const token = TokenJson?.token || ""
  const [cities, setCities] = useState([])
  const [products, setProducts] = useState([])
  const [selectedCityOptions, setSelectedCityOptions] = useState([])
  const Advertisement = sessionStorage.getItem("Advertisementid")
  const [categories, setCategories] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [labels, setLabels] = useState("")

  const handleCitySelect = selectedOptions => {
    setSelectedCityOptions(selectedOptions)
  }

  const handleChange = e => {
    const { name, value } = e.target
    setForm(prev => ({
      ...prev,
      [name]: value,
    }))

    if (name === "priorityId" && value) {
      fetchCities(value)
      const selectedPriority = priority.find(p => p._id === value)
      if (selectedPriority) {
        setPrice(selectedPriority.price)
      }
    } else if (name === "priorityId" && !value) {
      setCities([])
      setSelectedCityOptions([])
      setLabels("")
    }
  }

  const fetchCities = useCallback(
    debounce(async Id => {
      if (!token) {
        toast.error("Authentication token not found")
        return
      }

      try {
        const response = await axios.post(
          URLS.AdvPriorityLocations,
          { advpriceId: Id },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        setCities(response.data.data?.values || [])
        setLabels(response.data.data?.label || "")
      } catch (error) {
        console.error("Fetch cities error:", error)
        toast.error("Failed to fetch cities")
      }
    }, 300),
    [token]
  )

  const getCategories = useCallback(async () => {
    if (!token) {
      toast.error("Authentication token not found")
      return
    }

    try {
      const response = await axios.post(
        URLS.GetAdvertisementCategory,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      setCategories(response.data.advcategorys || [])
    } catch (error) {
      console.error("Fetch categories error:", error)
      toast.error("Failed to fetch categories")
    }
  }, [token])

  const getProducts = useCallback(async () => {
    if (!token) {
      toast.error("Authentication token not found")
      return
    }

    try {
      const response = await axios.post(
        URLS.GetProduct,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      setProducts(response.data.products || [])
    } catch (error) {
      console.error("Fetch products error:", error)
      toast.error("Failed to fetch products")
    }
  }, [token])

  const handleCategoryChange = async e => {
    const { value } = e.target
    setForm(prev => ({
      ...prev,
      advcategoryId: value,
      priorityId: "",
    }))
    setPriority([])
    setCities([])
    setSelectedCityOptions([])
    setLabels("")
    setPrice("")

    if (value && token) {
      try {
        const response = await axios.post(
          URLS.GetAdvertisementByPriority,
          { advcategoryId: value },
          { headers: { Authorization: `Bearer ${token}` } }
        )
        setPriority(response.data.data || [])
      } catch (error) {
        console.error("Fetch priorities error:", error)
        toast.error("Failed to fetch priorities")
      }
    }
  }

  useEffect(() => {
    setIsLoading(true)
    Promise.all([getCategories(), getProducts()])
      .then(() => GetOneAdvertisementData())
      .catch(error => {
        console.error("Initialization error:", error)
      })
      .finally(() => setIsLoading(false))
  }, [getCategories, getProducts])

  const cityOptions =
    cities?.map(city => ({
      value: city.id,
      label: city.name,
    })) || []

  const handleSubmit = e => {
    e.preventDefault()

    if (!token) {
      toast.error("Authentication token not found")
      return
    }

    if (selectedCityOptions.length === 0) {
      toast.error("Please select at least one city")
      return
    }

    // Validate dates
    if (form.fromDate && form.toDate) {
      const fromDate = new Date(form.fromDate)
      const toDate = new Date(form.toDate)

      if (toDate < fromDate) {
        toast.error("End date cannot be before start date")
        return
      }
    }

    setIsLoading(true)
    const delieverIds = selectedCityOptions.map(option => option.value)

    const formData = new FormData()
    formData.append("name", form.name)
    formData.append("priorityId", form.priorityId)
    formData.append("advcategoryId", form.advcategoryId)
    formData.append("advtype", form.advtype)
    formData.append("fromDate", form.fromDate)
    formData.append("toDate", form.toDate)
    formData.append("productId", form.productId)
    formData.append("type", form.type)
    formData.append("deltype", labels)
    formData.append("delieverIds", JSON.stringify(delieverIds))

    // Only append image if a new file is selected
    if (selectedFiles.length > 0) {
      for (let i = 0; i < selectedFiles.length; i++) {
        formData.append("image", selectedFiles[i].file || selectedFiles[i])
      }
    }

    axios
      .put(URLS.EditAdvertisement + Advertisement, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then(res => {
        if (res.status === 200) {
          toast.success(res.data.message)
          history.push("/Advertisements")
        }
      })
      .catch(error => {
        if (error.response) {
          toast.error(error.response.data.message || "Update failed")
        } else {
          toast.error("Network error occurred")
        }
      })
      .finally(() => setIsLoading(false))
  }

  function handleAcceptedFiles(files) {
    if (files.length === 0) return

    const file = files[0]
    const fileType = file.type.split("/")[0]
    const allowedTypes = {
      image: ["image"],
      video: ["video"],
      reel: ["video"],
    }

    if (!allowedTypes[form.type]?.includes(fileType)) {
      toast.error(`Please select a ${form.type} file`)
      return
    }

    const maxSize = form.type === "image" ? 10 * 1024 * 1024 : 50 * 1024 * 1024
    if (file.size > maxSize) {
      toast.error(
        `File size too large. Max ${
          form.type === "image" ? "10MB" : "50MB"
        } allowed`
      )
      return
    }

    Object.assign(file, {
      preview: fileType === "image" ? URL.createObjectURL(file) : null,
      formattedSize: formatBytes(file.size),
    })

    setSelectedFiles([file])
    setExistingImage("")
  }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  const getAcceptedFileTypes = () => {
    switch (form.type) {
      case "image":
        return "image/*"
      case "video":
      case "reel":
        return "video/*"
      default:
        return "image/*"
    }
  }

  const GetOneAdvertisementData = () => {
    const data = {
      id: Advertisement,
    }

    axios
      .post(URLS.GetOneAdvertisement, data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(res => {
        const AdvertisementData = res?.data?.advertisement || {}

        setForm(prev => ({
          ...prev,
          name: AdvertisementData.name || "",
          advcategoryId: AdvertisementData.advcategoryId || "",
          priorityId: AdvertisementData.priorityId || "",
          storeId: AdvertisementData.storeId || "",
          type: AdvertisementData.type || "image",
          advtype: AdvertisementData.advtype || "",
          productId: AdvertisementData.productId || "",
          deltype: AdvertisementData.deltype || "",
          fromDate: AdvertisementData.fromDate
            ? AdvertisementData.fromDate.split("T")[0]
            : "",
          toDate: AdvertisementData.toDate
            ? AdvertisementData.toDate.split("T")[0]
            : "",
        }))

        if (AdvertisementData.image) {
          setExistingImage(URLS.Base + AdvertisementData.image)
        }

        if (AdvertisementData.delieverIds?.length > 0) {
          const cityOptions = AdvertisementData.delieverIds.map(id => ({
            value: id,
            label: AdvertisementData.deliveryIdsNames,
          }))
          setSelectedCityOptions(cityOptions)
        }

        if (AdvertisementData.priorityId) {
          fetchCities(AdvertisementData.priorityId)
          const selectedPriority = priority.find(
            p => p._id === AdvertisementData.priorityId
          )
          if (selectedPriority) {
            setPrice(selectedPriority.price)
          }
        }

        if (AdvertisementData.advcategoryId) {
          axios
            .post(
              URLS.GetAdvertisementByPriority,
              { advcategoryId: AdvertisementData.advcategoryId },
              { headers: { Authorization: `Bearer ${token}` } }
            )
            .then(response => {
              setPriority(response.data.data || [])
            })
            .catch(error => {
              toast.error("Failed to fetch priorities")
              console.error("Priority fetch error:", error)
            })
        }
      })
      .catch(error => {
        console.error("Error fetching advertisement data:", error)
        toast.error("Failed to load advertisement data")
      })
  }

  if (isLoading) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="text-center my-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </Container>
      </div>
    )
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Bizzmate Supplier"
            breadcrumbItem="Edit Advertisements"
          />
          <Form onSubmit={handleSubmit}>
            <Card>
              <CardBody>
            <Row>
              <Col xl="12">
                <Button
                  onClick={() => history.goBack()}
                  className="mb-2"
                  style={{ float: "right" }}
                  color="primary" 
                  size="sm"
                >
                  <i className="far fa-arrow-alt-circle-left me-2"></i>
                  Back
                </Button>
              </Col>
            </Row>
                <Row >
                  <Col lg="8">
                    <FormGroup>
                      <Label>Type </Label>
                      <span className="text-danger">*</span>
                      <Input
                        type="select"
                        name="type"
                        value={form.type}
                        onChange={handleChange}
                        required
                        disabled
                      >
                        <option value="image">Image</option>
                        <option value="video">Video</option>
                        <option value="reel">Reel</option>
                      </Input>
                    </FormGroup>
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Name <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        placeholder="Enter Name"
                        required
                        value={form.name}
                        name="name"
                        onChange={handleChange}
                      />
                    </div>
                    <div className="mb-3">
                      <Label>Advertisements Category Name</Label>
                      <span className="text-danger">*</span>
                      <Input
                        type="select"
                        value={form.advcategoryId}
                        name="advcategoryId"
                        required
                        onChange={handleCategoryChange}
                        className="form-select"
                        disabled
                      >
                        <option value="">Select</option>
                        {categories.map(data => (
                          <option key={data._id} value={data._id}>
                            {data.name}
                          </option>
                        ))}
                      </Input>
                    </div>
                    <div className="mb-3">
                      <Label>Priority</Label>
                      <span className="text-danger">*</span>
                      <Input
                        type="select"
                        value={form.priorityId}
                        name="priorityId"
                        required
                        onChange={handleChange}
                        className="form-select"
                        // disabled={!form.advcategoryId}
                        disabled
                      >
                        <option value="">Select</option>
                        {priority.map(data => (
                          <option key={data._id} value={data._id}>
                            Priority : {data.priority} , Customer Reach :{" "}
                            {data.CustomerReach} Price: {data.price}/-
                          </option>
                        ))}
                      </Input>
                    </div>
                    {/* Price Display Section */}
                    {price && (
                      <div className="mb-3">
                        <Label htmlFor="price-display">
                          Deal Price <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="text"
                          className="form-control bg-light"
                          id="price-display"
                          value={`₹ ${price}`}
                          readOnly
                          style={{ fontWeight: "bold", fontSize: "16px" }}
                        />
                        <small className="text-muted">
                          This is the amount you'll be charged for creating this
                          deal
                        </small>
                      </div>
                    )}
                    <Row>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="start-date-input">
                            Start Date <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="date"
                            className="form-control"
                            id="start-date-input"
                            placeholder="Enter Start Date"
                            required
                            value={form.fromDate}
                            name="fromDate"
                            onChange={handleChange}
                            min={new Date().toISOString().split("T")[0]}
                            disabled
                          />
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="mb-3">
                          <Label htmlFor="end-date-input">
                            End Date
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            type="date"
                            className="form-control"
                            id="end-date-input"
                            placeholder="Enter End Date"
                            required
                            value={form.toDate}
                            name="toDate"
                            onChange={handleChange}
                            disabled
                            min={
                              form.fromDate ||
                              new Date().toISOString().split("T")[0]
                            }
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="mb-3">
                      <Label>Adv Type</Label>
                      <span className="text-danger">*</span>
                      <Input
                        type="select"
                        value={form.advtype}
                        name="advtype"
                        required
                        onChange={handleChange}
                        className="form-select"
                        disabled
                      >
                        <option value="">Select</option>
                        <option value="store">Store</option>
                        <option value="product">Product</option>
                      </Input>
                    </div>
                    {form.advtype === "product" && (
                      <div className="mb-3">
                        <Label>Products</Label>
                        <span className="text-danger">*</span>
                        <Input
                          type="select"
                          isDisabled={true}
                          value={form.productId}
                          name="productId"
                          required={form.advtype === "product"}
                          onChange={handleChange}
                          className="form-select"
                        >
                          <option value="">Select</option>
                          {products.map(data => (
                            <option key={data._id} value={data._id}>
                              {data.name}
                            </option>
                          ))}
                        </Input>
                      </div>
                    )}
                    <Col md="12">
                      <FormGroup className="mb-3">
                        <Label htmlFor="city-select">
                          {labels || "locations"}
                          <span className="text-danger">*</span>
                        </Label>
                        <Select
                          id="city-select"
                          isDisabled={true}
                          placeholder="Select locations"
                          value={selectedCityOptions}
                          options={cityOptions}
                          isSearchable={true}
                          onChange={handleCitySelect}
                          isMulti
                          aria-label="Select locations"
                        />
                      </FormGroup>
                    </Col>
                  </Col>
                  <Col lg="4" className="mb-4">
                    <div className="m-2">
                      <h5 style={{ fontWeight: "bold" }}>{form.type} Upload</h5>
                      <div className="w-100">
                        <Dropzone
                          onDrop={acceptedFiles => {
                            handleAcceptedFiles(acceptedFiles)
                          }}
                          accept={getAcceptedFileTypes()}
                          multiple={false}
                        >
                          {({ getRootProps, getInputProps }) => (
                            <div className="dropzone">
                              <div
                                className="dz-message needsclick mt-2"
                                {...getRootProps()}
                              >
                                <input {...getInputProps()} />
                                <div className="mb-3">
                                  <i className="display-4 text-muted bx bxs-cloud-upload" />
                                </div>
                                <h4>
                                  Drop {form.type} file here or click to upload
                                </h4>
                                <p className="text-muted">
                                  {form.type === "image"
                                    ? "Supports JPG, PNG (Max 10MB)"
                                    : "Supports MP4, MOV (Max 50MB)"}
                                </p>
                              </div>
                            </div>
                          )}
                        </Dropzone>
                        <div
                          className="dropzone-previews mt-3"
                          id="file-previews"
                        >
                          {/* Show existing image if no new file is selected */}
                          {existingImage && selectedFiles.length === 0 && (
                            <Card className="mt-1 mb-0 shadow-none border">
                              <div className="p-2">
                                <Row className="align-items-center">
                                  <Col className="col-auto">
                                    <img
                                      height="40"
                                      className="avatar-sm rounded bg-light"
                                      alt="Existing advertisement"
                                      src={existingImage}
                                    />
                                  </Col>
                                  <Col>
                                    <p className="mb-0">
                                      <small>Existing {form.type}</small>
                                    </p>
                                  </Col>
                                </Row>
                              </div>
                            </Card>
                          )}
                          {/* Show selected files */}
                          {selectedFiles.map((f, i) => (
                            <Card
                              className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                              key={i + "-file"}
                            >
                              <div className="p-2">
                                <Row className="align-items-center">
                                  {f.preview ? (
                                    <Col className="col-auto">
                                      <img
                                        data-dz-thumbnail=""
                                        height="40"
                                        className="avatar-sm rounded bg-light"
                                        alt={f.name}
                                        src={f.preview}
                                      />
                                    </Col>
                                  ) : (
                                    <Col className="col-auto">
                                      <i
                                        className="bx bxs-video text-primary"
                                        style={{ fontSize: "2rem" }}
                                      />
                                    </Col>
                                  )}
                                  <Col>
                                    <Link
                                      to="#"
                                      className="text-muted font-weight-bold"
                                    >
                                      {f.name}
                                    </Link>
                                    <p className="mb-0">
                                      <strong>{f.formattedSize}</strong>
                                    </p>
                                    <p className="mb-0">
                                      <small>Type: {form.type}</small>
                                    </p>
                                  </Col>
                                </Row>
                              </div>
                            </Card>
                          ))}
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="mb-2" style={{ float: "right" }}>
                      <Button
                        type="submit"
                        style={{ width: "120px" }}
                        color="primary"
                        className="m-1 btn-sm"
                        disabled={isLoading}
                      >
                        {isLoading ? "Processing..." : "Submit"}
                        {!isLoading && (
                          <i className="fas fa-check-circle ms-1"></i>
                        )}
                      </Button>
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Form>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default EditAdvertisements
